import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/create-account-background-mobile.svg")